<template>
  <!-- Displays the date format -->
  <span v-if="!!value">{{localizedValue}}</span>
</template>

<script>
import moment from "moment"
import localization from "@/_mixins/localization-mixin"
export default {
  name: "LocalizedDate",
  mixins : [localization],
  props : {
    /**
     * Date value sent via props
     */
    value : {type:null, default:null},
    /**
     * Displays the date in various format like mm/dd/yyyy or dd-mm-yy
     */
    format : {type:String, default:null},
    /**
     * Checks the value type as date or not
     */
    date : {type:Boolean, default: true},
    /**
     * Time can send besides to date
     */
    time : {type:Boolean, default: false},/**
     * Date format type
     */
    short : {type:Boolean, default: false},
    /**
     * Shows the date difference from now to given date
     */
    "from-now" : {type:Boolean, default: false},
    /**
     * Sets time zone based on GMT
     */
    "time-zone-sensitive" : {type:Boolean, default: false},
  },
  computed : {
    // Display the date
    localizedValue()
    {
      // Checks if the date have to be displayed from current date
      if(this.fromNow)
      {
        return moment(this.value).fromNow();
      }

      var ret = [];
      // Format the date and display in the page
      if(this.date) {ret.push(this.formatDate(this.value))}

      return ret.join(" ");
      
    }
  }
};
</script>

<style scoped lang="scss"></style>
